import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">adityacyan</h1>

                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Projects</a>
                    </li>

                    <li>
                        <a href="#services" className="footer__link">Coding Profiles</a>
                    </li>
                </ul>

                <div className="footer__social">
                    <a href="https://github.com/adityacyan" className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-github"></i>
                    </a>

                    <a href="https://www.linkedin.com/in/adityacyan/" className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-linkedin"></i>
                    </a>

                    <a href="https://x.com/Aditya05644494" className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-twitter"></i>
                    </a>
                </div>

                <span className='footer__copy'>
                    &#169; Aditya R. All rigths reserved
                </span>
            </div>
        </footer>
    )
}

export default Footer